import { render, staticRenderFns } from "./lgnFormItem.vue?vue&type=template&id=2fa3a73a&"
import script from "./lgnFormItem.vue?vue&type=script&lang=js&"
export * from "./lgnFormItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports